import { SimpleSelect } from '@workwave-tidal/core/components'
import { useRecurrenceWhen } from '../../../providers/StateProvider'
import { createRecurrenceWhenId } from './utils/createRecurrenceWhenId'
import { useOptions } from './useOptions'
import { useTexts } from './useTexts'
import { useOnChange } from './useOnChange'
import { Box } from '@mui/material'

type RecurrenceWhenDropdownProps = {
  testId?: string
}

export function RecurrenceWhenDropdown(props: RecurrenceWhenDropdownProps) {
  const { testId = 'RecurrenceWhenDropdown' } = props
  const when = useRecurrenceWhen()
  const options = useOptions()
  const onChange = useOnChange()
  const texts = useTexts()

  const selectedIds = when ? createRecurrenceWhenId(when) : undefined

  return (
    <Box data-testid={testId} width="50%">
      <SimpleSelect
        label={texts.label}
        name="recurrenceWhen"
        value={selectedIds}
        options={options}
        onChange={onChange}
      />
    </Box>
  )
}
